import { forwardRef } from 'react';
import {
	Button as ChakraButton,
	Flex,
	Spinner,
	Box,
	ButtonProps,
} from '@chakra-ui/react';

export interface LoadingButtonProps extends ButtonProps {
	isLoading?: boolean;
	loadingText?: string;
}

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
	({ isLoading = false, loadingText, children, ...rest }, ref) => {
		const label = isLoading && loadingText ? loadingText : children;

		return (
			<ChakraButton ref={ref} {...rest}>
				<Flex align="center">
					<Spinner
						size="sm"
						display={isLoading ? 'inline-block' : 'none'}
						mr={isLoading ? 2 : 0}
					/>
					<Box as="span" whiteSpace="nowrap">
						{label}
					</Box>
				</Flex>
			</ChakraButton>
		);
	},
);

LoadingButton.displayName = 'LoadingButton';
